import { debounceTime } from 'rxjs/operators';
import { ComponentSelectionStorageService } from '@sdbn/common';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { ContextChange, WidgetStyle } from '@sdbn/common';
import { AbstractWidgetComponent } from '@sdbn/common';
import { TranslationService } from '@sdbn/common';
import { TypeFilter, VisitorType, VisitorUpfrontRegistationFilterModel } from '../visitor-upfront-registration-filter.model';

const CUSTOM_FILTER_SELECTION_KEY = 'visitor-upfront-registration-filter.selection';


@Component({
    selector: 'app-visitor-upfront-registration-filter',
    templateUrl: './visitor-upfront-registration-filter.component.html',
    styleUrls: ['./visitor-upfront-registration-filter.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class VisitorUpfrontRegistrationFilterComponent extends AbstractWidgetComponent implements OnInit, OnDestroy {

  valueAdjusting = false;

  filterSubscription: Subscription;
  selectedCustomFilter: number;

  scopeFilters = new Array<TypeFilter>();

  filterFormGroup = new FormGroup({});

  constructor(
    public translationService: TranslationService,
    private componentSelectionStorageService: ComponentSelectionStorageService,
  ) {
    super();
    const filter = new TypeFilter();
    filter.id = 'person';
    filter.icon = 'fa-light fa-sharp fa-user'; // we use the same CSS as in table
    filter.title = 'tmc.visit.overview.visitors.filter.visitor.title';
    filter.visitorType = VisitorType.VISITOR;
    this.scopeFilters.push(filter);

    const filterGroup = new TypeFilter();
    filterGroup.id = 'group';
    filterGroup.icon = 'fa-light fa-sharp fa-users'; // we use the same CSS as in table
    filterGroup.title = 'tmc.visit.overview.visitors.filter.visitorgroup.title';
    filterGroup.visitorType = VisitorType.VISITORGROUP;
    this.scopeFilters.push(filterGroup);

    this.filterFormGroup.addControl('filterText', new FormControl(null, []));
    this.filterFormGroup.valueChanges.pipe(debounceTime(300)).subscribe(
      value => {
        if (this.filterFormGroup.dirty) {
          this.handleFilterChanged();
        }
      }
    );
  }

  ngOnInit() {

    this.restoreFilter();
  }

  ngOnDestroy() {

    super.ngOnDestroy();

    if (this.filterSubscription) {
      this.filterSubscription.unsubscribe();
    }
  }

  private restoreFilter() {

    try {
      const model: VisitorUpfrontRegistationFilterModel = this.componentSelectionStorageService.get(CUSTOM_FILTER_SELECTION_KEY);

      if (model != null) {

        const values: any = {};
        // restore text filter
        if (model.filterText != null) {
          values.filterText = model.filterText;
        }

        this.filterFormGroup.reset(values);
      }
    } finally {
      this.handleFilterChanged();
    }
  }

  public applyQuickFilter(item: TypeFilter) {
    item.selected = !item.selected;
    this.handleFilterChanged();
  }

  private handleFilterChanged() {
    const model = new VisitorUpfrontRegistationFilterModel();
    model.filterText = this.filterFormGroup.controls.filterText.value;
    for (const scopeFilter of this.scopeFilters) {
      if (scopeFilter.selected) {
        model.visitorTypes.push(scopeFilter.visitorType);
      }
    }
    this.componentSelectionStorageService.save(CUSTOM_FILTER_SELECTION_KEY, model);
    this.dashboardContext.setContextValue('visitor-upfront-registration-selection', model);
  }

  onContextChange(contextChange: ContextChange) {
  }

  onSetElementAndContext() {
  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }
}
